import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class AddendumsDB extends GenericDB {
  constructor(sessionActivityId = null) {
    super('', 'sessionActivities.addendums');
    this.setSessionActivityId(sessionActivityId);
  }

  setSessionActivityId(sessionActivityId) {
    this.sessionActivityId = sessionActivityId;
  }

  getCollectionRef() {
    if (!this.sessionActivityId) {
      throw new Error('AddendumsDB: sessionActivityId is required');
    }
    return collection(db, 'sessionActivities', this.sessionActivityId, 'addendums');
  }

  /**
   * Reads non-deleted addendums ordered by creation time, oldest first
   */
  async readChronological() {
    return this.readAll([['isDeleted', '==', false]], 'createTimestamp', 'asc');
  }
}
